import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import AdminUserRegisterForm from "../../components/auth/AdminUserRegisterForm";
import { useAuthActions } from "../../features/auth/useAuthActions";

export default function AdminUserRegisterPage() {

  const { adminCreateUser } = useAuthActions();

  const navigate = useNavigate();
  const location = useLocation();

  const role = location.state?.role;

  const [loading, setLoading] = useState(false);
  const [globalError, setGlobalError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleSubmit = async (formData) => {
  setLoading(true);
  setGlobalError("");
  setSuccessMessage("");

  try {
    await adminCreateUser({
      phoneNumber: formData.phoneNumber,
      fullName: formData.fullName,
      role: role,
    });

    setSuccessMessage("کاربر با موفقیت ایجاد شد.");

    setTimeout(() => {
      navigate(-1);
    }, 1000);

  } catch (error) {
    console.error(error);

    if (error.response?.status === 400) {
      setGlobalError(
        error.response?.data?.detail ||
        "این شماره موبایل قبلاً ثبت شده است."
      );
    } else {
      setGlobalError("ایجاد کاربر با خطا مواجه شد.");
    }
  } finally {
    setLoading(false);
  }
};


  const roleTitle =
    role === "admin" ? "ثبت نام کارمند" :
    role === "supplier" ? "ثبت نام تأمین کننده" :
    "ثبت کاربر";

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50 px-4 py-8">

      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md border">

        {/* Header */}
        <div className="mb-6 text-center relative">

          <h1 className="text-xl font-medium mt-2">
            {roleTitle}
          </h1>

          <Link to={-1}>
            <FaArrowRight className="absolute right-0 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-800" />
          </Link>

        </div>

        <AdminUserRegisterForm
          onSubmit={handleSubmit}
          isLoading={loading}
        />

        {globalError && (
          <p className="text-red-600 text-sm mt-4 text-center">
            {globalError}
          </p>
        )}

        {successMessage && (
          <p className="text-green-600 text-sm mt-4 text-center">
            {successMessage}
          </p>
        )}

      </div>

    </div>
  );
}
